// Plantillas de mail del "Escribir" del Radar Comercial (Fase B) — BORRADOR para que Ignacio las
// corrija, ver docs/decisiones/2026-09-26-radar-mail-pagina-diseno.md §3.5. Español neutro
// latinoamericano en TÚ ("tienes", no "tenés"): las leen clientes chilenos y peruanos por igual.
//
// Dos plantillas (cliente/agencia), cada una con un primer párrafo variable según `tipo`
// (compró / se propuso y no cerró) y, salvo el caso agencia+propuso (su párrafo variable ya
// incluye la pregunta de cierre), un segundo párrafo de llamada a la acción fijo.
//
// Frase de crecimiento ("hoy la red tiene M edificios, N entonces") es TODO o NADA: si falta N
// (edificiosTotales de la venta de referencia) o M (edificios operativos hoy, ver
// getEdificiosOperativos), la frase se omite entera — nunca sale un número flojo hacia un
// cliente. `haycrecimiento` decide, una sola vez, para toda la plantilla.

const MARCA_POR_PAIS = { Chile: "Wecast", Perú: "Visiona" };
export const marcaPorPais = (pais) => MARCA_POR_PAIS[pais] || "Wecast";

const primerNombre = (nombreCompleto) => (nombreCompleto || "").trim().split(/\s+/)[0] || "";

const parrafoCliente = ({ tipo, mes, campanaTxt, hayCrecimiento, nEntonces, nHoy }) => {
  if (tipo === "compro") {
    return hayCrecimiento
      ? `En ${mes} del año pasado hicimos juntos ${campanaTxt}, en ${nEntonces} edificios de nuestra red.\n\nHoy la red tiene ${nHoy} edificios, y me gustaría proponerte repetirla con más alcance.`
      : `En ${mes} del año pasado hicimos juntos ${campanaTxt}.\n\nMe gustaría proponerte repetirla con más alcance.`;
  }
  return hayCrecimiento
    ? `En ${mes} del año pasado te presentamos ${campanaTxt} y quedó sin concretarse. Hoy la red tiene ${nHoy} edificios (${nEntonces} entonces), y creo que vale la pena volver a mirarla.`
    : `En ${mes} del año pasado te presentamos ${campanaTxt} y quedó sin concretarse. Creo que vale la pena volver a mirarla.`;
};

const parrafoAgencia = ({ tipo, mes, campanaTxt, empresa, hayCrecimiento, nEntonces, nHoy }) => {
  if (tipo === "compro") {
    return hayCrecimiento
      ? `En ${mes} del año pasado salimos con ${campanaTxt} de ${empresa} en ${nEntonces} edificios. Hoy son ${nHoy}.`
      : `En ${mes} del año pasado salimos con ${campanaTxt} de ${empresa}.`;
  }
  // "Se propuso y no cerró": el párrafo ya incluye la pregunta de cierre, sin segundo párrafo.
  return hayCrecimiento
    ? `En ${mes} del año pasado te propusimos ${campanaTxt} para ${empresa} y quedó fuera del plan. Hoy la red tiene ${nHoy} edificios (${nEntonces} entonces). ¿Lo revisamos para ${mes}?`
    : `En ${mes} del año pasado te propusimos ${campanaTxt} para ${empresa} y quedó fuera del plan. ¿Lo revisamos para ${mes}?`;
};

/**
 * Arma asunto + cuerpo del mail del Radar.
 * @param {{lado:'cliente'|'agencia', tipo:'compro'|'propuso', empresa:string, campana:string|null,
 *   mes:string, nEntonces:number|null, nHoy:number|null, firma:string, pais:string,
 *   nombreContacto?:string}} datos
 * @returns {{asunto:string, cuerpo:string}}
 */
export const armarMailRadar = ({ lado, tipo, empresa, campana, mes, nEntonces, nHoy, firma, pais, nombreContacto }) => {
  const campanaTxt = campana || "una campaña";
  const marca = marcaPorPais(pais);
  const hayCrecimiento = nEntonces != null && nHoy != null;
  const nombre = primerNombre(nombreContacto);
  const saludo = nombre ? `Hola ${nombre},` : "Hola,";

  const parrafo1 =
    lado === "agencia"
      ? parrafoAgencia({ tipo, mes, campanaTxt, empresa, hayCrecimiento, nEntonces, nHoy })
      : parrafoCliente({ tipo, mes, campanaTxt, hayCrecimiento, nEntonces, nHoy });

  const bloques = [saludo, parrafo1];
  if (lado === "cliente") {
    bloques.push("¿Tienes diez minutos esta semana para verlo?");
  } else if (tipo === "compro") {
    bloques.push(`¿Lo ponemos en el plan de ${mes} de este año? Te mando la propuesta actualizada cuando me digas.`);
  }
  bloques.push(`${firma}\n${marca}`);

  return {
    asunto: `${empresa} · ${campanaTxt} · ${mes}`,
    cuerpo: bloques.join("\n\n"),
  };
};
